import React from "react";
import { Link } from "react-router-dom";

import { getImgUrl } from "../../Utility/Utility";
import { Img } from "../../Components/UI/UI";
import "./Footer.css";

const Footer = () => {
  return (
    <div className="Footer-outer-wrapper">
      <div className="container">
        <div className="row">
          <div className="col col-100 footer-menu-outer-wrapper">
            {/* <div className="footer-images-wrapper">
              <div className="tripadvisor-main-wrapper">
                <Img desktopImg="Footer/tripadvisorMain.png" />
              </div>
              <div className="info-main-wrapper">
                <a href="https://www.gov.il/en/service/virtual_office/">
                  <Img desktopImg="support.png" />
                </a>
              </div>
            </div> */}
            <div className="footer-menu-inner-wrapper footer-menu-inner-wrapper-1">
              <ul className="first">
                <li>
                  <Link className="first" to="/Pages/whereToGo">
                    OÙ ALLER
                  </Link>
                </li>
                <li className="show-on-mobile">
                  <a>|</a>
                </li>
                <li>
                  <Link to="/Pages/TelAvivPage">TEL AVIV</Link>
                </li>
                <li className="show-on-mobile">
                  <a>|</a>
                </li>
                <li>
                  <Link to="/Pages/JerusalemPage">JÉRUSALEM</Link>
                </li>
                <li className="show-on-mobile">
                  <a>|</a>
                </li>
                <li>
                  <Link to="/Pages/DeadSeaPage">MER MORTE</Link>
                </li>
                <li className="show-on-mobile">
                  <a>|</a>
                </li>
              </ul>

              <ul>
                <li>
                  <Link className="first" to="/Pages/thingsToDo">
                    À FAIRE...
                  </Link>
                </li>
                <li className="show-on-mobile">
                  <a>|</a>
                </li>
                <li>
                  <Link to="/Posts/telaviv/Sensational_Beaches">
                    PLAGES SENSATIONNELLES
                  </Link>
                </li>
                <li className="show-on-mobile">
                  <a>|</a>
                </li>
                <li>
                  <Link to="/Posts/telaviv/Go_To_Guide">GO TO GUIDE</Link>
                </li>
                <li className="show-on-mobile">
                  <a>|</a>
                </li>
                <li>
                  <Link to="/Posts/telaviv/Day_IsTrippin">
                    UNE JOURNÉE À TEL AVIV
                  </Link>
                </li>
                <li className="show-on-mobile">
                  <a>|</a>
                </li>
              </ul>

              <ul className="">
                <li>
                  <Link className="first" to="/Pages/Videos">
                    VIDÉOS
                  </Link>
                </li>
                <li className="show-on-mobile">
                  <a>|</a>
                </li>
                <li>
                  <Link to="/Posts/Videos/telaviv/Outdoor_Adventures">
                    AVENTURES EN PLEIN AIR
                  </Link>
                </li>
                <li className="show-on-mobile">
                  <a>|</a>
                </li>
                <li>
                  <Link to="/Posts/Videos/deadsea/Natural_Spa">MER MORTE</Link>
                </li>
                <li className="show-on-mobile">
                  <a>|</a>
                </li>
                <li>
                  <Link to="/Posts/Videos/telaviv/Port_Pleasures">
                    PLAISIRS PORTUAIRES
                  </Link>
                </li>
                <li className="show-on-mobile">
                  <a>|</a>
                </li>
              </ul>

              <div className="clear"></div>
            </div>
            <div className="clear"></div>
            {/* <div className="ac-wrapper-telaviv-and-jerusalem-footer ac-flex ac-flex-row ac-flex-row-mob">
              <div className="telaviv-and-jerusalem-footer">
                <a
                  className="jer-site"
                  href="https://www.itraveljerusalem.com/"
                  target="_blank"
                >
                  LE SITE OFFICIEL DU TOURISME À JÉRUSALEM >>
                </a>
              </div>
              <div className="ac-verti-line hide-on-mobile"> </div>
              <div className="telaviv-and-jerusalem-footer">
                <a
                  className="tlv-site"
                  href="https://visit.tel-aviv.gov.il/home"
                  target="_blank"
                >
                  LE SITE OFFICIEL DU TOURISME À TEL-AVIV >>
                </a>
              </div>
              <div className="telaviv-and-jerusalem-footer">
                <a
                  className="ac-privacy-policy"
                  href="https://fr.goisrael.com/Posts/telaviv/Privacy_Policy"
                  target="_blank"
                >
                  PRIVACY POLICY >>
                </a>
              </div>
            </div> */}
          </div>
        </div>
        <div className="ac-social-wrapper">
                  <div className="ac-inner-social-wrapper">
                        <div className="ac-social-col ac-social-col-1">
                              <a href="https://www.instagram.com/visit_israel/" >
                              <Img desktopImg="social/i.png" mobileImg="social/i.png"/>
                              </a>
                        </div>
                        {/* <div className="ac-social-col ac-social-col-2">
                              <a href="https://twitter.com/israeltourism" onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'footer', 'click_cta':'twitter', 'event_details':'', }})}>
                              <Img desktopImg="social/t.png" mobileImg="social/t.png"/>
                              </a>
                        </div> */}
                        <div className="ac-social-col ac-social-col-3">
                              <a href="https://www.youtube.com/@goisraelofficial" >
                              <Img desktopImg="social/y.png" mobileImg="social/y.png"/>
                              </a>
                        </div>
                        <div className="ac-social-col ac-social-col-4">
                              <a href="https://www.flickr.com/photos/israelphotogallery/sets/">
                              <Img desktopImg="social/fl.png" mobileImg="social/fl.png"/>
                              </a>
                        </div>
                        <div className="ac-social-col ac-social-col-5">
                              <a href="https://www.facebook.com/voyage.en.israel" >
                              <Img desktopImg="social/f.png" mobileImg="social/f.png"/>
                              </a>
                        </div>
                        <div className="ac-social-col ac-social-col-6">
                              <a href="https://www.tiktok.com/@visit_israel">
                              <Img desktopImg="social/tiktok.png" mobileImg="social/tiktok.png"/>
                              </a>
                        </div>
                        <div className="ac-social-col ac-social-col-7">
                              <a href="https://www.linkedin.com/company/israel-ministry-of-tourism/">
                              <Img desktopImg="social/linkedin.png" mobileImg="social/linkedin.png"/>
                              </a>
                        </div>
                  </div>
        </div>
        <div className="row">
          <div className="cradit">
            <p>
              Photographers: Guy Yehieli, Adam Primer, Kfir Boltin, Linnea
              Andres, Kfir Sivan, Haim Yafim, Dana Fridlander, refael Ben Ari,
              Itamar Greenberg, Moshik Lindbaum
            </p>
            <p>
              Video Credits: Israeli food channel, Tel Aviv Jaffa municipality,
              UDINI prodactions
            </p>
          </div>

          {/* <h4>Pour Plus D'offres:</h4>
          <div className="clear"></div>
          <div className="sites-logos">
            <div className="anoter-site-deal-logo">
              <a
                rel="noopener noreferrer"
                target="_blank"
                href="https://www.tripadvisor.co.uk/Hotels-g293984-Tel_Aviv_Tel_Aviv_District-Hotels.html"
              >
                <Img desktopImg={"Footer/1.png"} />
              </a>
            </div>

            <div className="anoter-site-deal-logo">
              <a
                rel="noopener noreferrer"
                target="_blank"
                href="https://www.trivago.co.uk/?aDateRange%5Barr%5D=2016-10-13&aDateRange%5Bdep%5D=2016-10-14&r=&cpt=8494803&iRoomType=1&aPriceRange%5Bfrom%5D=0&aPriceRange%5Bto%5D=0&iPathId=84948&iViewType=0&bIsSeoPage=0&bIsSitemap=false"
              >
                <Img desktopImg={"Footer/2.png"} />
              </a>
            </div>

            <div className="anoter-site-deal-logo">
              <a
                rel="noopener noreferrer"
                target="_blank"
                href="https://www.booking.com/city/il/tel-aviv.fr.html?label=gen173nr-1DCAMoakIIdGVsLWF2aXZIM2IFbm9yZWZoaogBAZgBMcIBCndpbmRvd3MgMTDIAQzYAQPoAQH4AQKSAgF5qAID;sid=f953bdba74eb94e49dfbc75c631266c4;inac=0;lang=fr;soz=1;lang_click=other;cdl=it"
              >
                <Img desktopImg={"Footer/3.png"} />
              </a>
            </div>

            <div className="anoter-site-deal-logo">
              <a
                rel="noopener noreferrer"
                target="_blank"
                href="https://www.expedia.com/Tourist-Information-Office-Tel-Aviv.d507139.Vacation-Attraction"
              >
                <Img desktopImg={"Footer/4.png"} />
              </a>
            </div>

            <div className="anoter-site-deal-logo">
              <a
                rel="noopener noreferrer"
                target="_blank"
                href="https://fr.hotels.com/de699178/hotels-tel-aviv-israel/"
              >
                <Img desktopImg={"Footer/5.png"} />
              </a>
            </div>
          </div> */}

          <div className="clear"></div>
        </div>
      </div>
      <div className="container container-links">
        <ul>
          <li><a href="https://brochures.goisrael.com/fr/"
                 target="_blank"
              >BROCHURE OFFICIELLE</a></li>
          <li><span> | </span></li>
          <li><a href="https://goisrael.com/Pages/Contact/"
                target="_blank"
              >NOUS CONTACTER</a></li>
               <li><span> | </span></li>
          <li><a href="https://israel.travel/terms-of-use/"
                  target="_blank"
              >CONDITIONS D'UTILISATION</a></li>
               <li><span> | </span></li>
          <li><a href="https://goisrael.com/Posts/telaviv/Privacy_Policy"
                  target="_blank"
              >
                  POLITIQUE DE CONFIDENTIALITÉ
                </a></li>
                 <li><span> | </span></li>
          <li><a href="https://fr.goisrael.com/Pages/Gallery/" 
                 target="_blank" 
              >GALERIE PHOTOS</a></li>
               <li><span> | </span></li>
          <li><a href="https://fr.goisrael.com/Posts/TouristInfo/Frequently_Asked_Questions"
                  target="_blank" 
              >FOIRE AUX QUESTIONS</a></li>
        </ul>
      </div>
      <br/>
    </div>
  );
};

export default Footer;



// WEBPACK FOOTER //
// ./src/Components/Footer/Footer.js